import Vue from 'vue'

export default {
  loadSettings: async (options) => {
    options = options || []
    const query = options.map(option => `options[]=${option}`).join('&')
    return Vue.axios.get('/settings?' + query);
  },
  async saveSettings (options) {
    if (!options) {
      return
    }

    let formData = new FormData()
    for (const prop in options) if (options.hasOwnProperty(prop)) {
      formData.append('options[' + prop + ']', options[prop])
    }

    return Vue.axios.post('/settings', formData)
  },

  loadRoles: async () => {
    return Vue.axios.get('/settings/manager-roles')
  },
  saveRole: async (role, edit) => {
    let formData = new FormData();
    for (const prop in role) if (role.hasOwnProperty(prop)) {
      formData.append('role[' + prop + ']', role[prop])
    }
    if (edit) {
      formData.append('edit', 'yes')
    }
    return Vue.axios.post('/settings/manager-roles', formData)
  },

  loadUsers: async () => {
    return Vue.axios.get('/settings/users-list')
  },
  loadUsersForRole: async (role) => {
    return Vue.axios.get('/settings/role-users/'+role.name)
  },
  appendUserToRole: async (user, role) => {
    const formData = new FormData()

    formData.append('user', user.id)
    formData.append('role', role.name)

    return Vue.axios.post('/settings/role-users/assign', formData)
  },
  dissociateUserFromRole: async (user, role) => {
    const formData = new FormData()

    formData.append('user', user.id)
    formData.append('role', role.name)

    return Vue.axios.post('/settings/role-users/dissociate', formData)
  },

  loadIndicatorsForRole(role) {
    return Vue.axios.get('/settings/role-indicators/'+role.name)
  },
  saveIndicatorsForRole(role, indicators) {
    const formData = new FormData()

    indicators.forEach(indicatorId => {
      formData.append('indicators[]', indicatorId)
    })

    return Vue.axios.post('/settings/role-indicators/'+role.name, formData)
  }
}
